module.exports = __webpack_public_path__ + "static/media/emojiGreat.00490439.svg";